export const formatDate = (date) => {
  if (!date) return '-';
  return new Date(date).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' });
};

export const formatCurrency = (amount) => {
  if (amount === null || amount === undefined) return '₹0';
  return `₹${Number(amount).toLocaleString('en-IN', { minimumFractionDigits: 2 })}`;
};

export const getInitials = (name) => {
  if (!name) return '?';
  return name.split(' ').map(n => n[0]).join('').toUpperCase().slice(0, 2);
};

export const getStatusColor = (status) => {
  const map = {
    active: 'success', inactive: 'danger', pending: 'warning',
    paid: 'success', approved: 'success', rejected: 'danger',
    present: 'success', absent: 'danger', late: 'warning',
    issued: 'primary', returned: 'success', overdue: 'danger',
    scheduled: 'info', completed: 'success', cancelled: 'danger',
  };
  return map[status?.toLowerCase()] || 'secondary';
};

export const truncate = (str, n = 40) => str?.length > n ? str.slice(0, n) + '...' : str;

export const debounce = (fn, delay) => {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => fn(...args), delay);
  };
};
